import $ from "jquery";

$(function() {
    $(".bl-accordion").on("click", ".summary", function() {
        const $accitem = $(this).closest(".accitem");
        const isexpanded = $accitem.hasClass("expanded");

        const $details = $accitem.find(".details");
        const animspeed = 200;

        if(!isexpanded) {
            $accitem.addClass("expanded");
            $details.slideDown(animspeed);    
        } else {
            $accitem.removeClass("expanded");
            $details.slideUp(animspeed);    
        }
    });
});